import "../styles/aboutUs.css";
import SectionTitle from "../components/SectionTitle";
import FoundingTeam from "../components/FoundingTeam";

const AboutUs = () => {
  return (
    <div className="about-us">
      <h1>About Us</h1>
        <div className="about-sections">
        {/* Our Story Card */}
        <div className="about-card">
      <SectionTitle title="Our Story" />
      <p>
      We aim to achieve a society with with highly intelligent entities that live up to maximum capacity of the human soul's lifespan.
      </p>
      <p>
      It all started as a simple Maths, Physics, and Life Sciences high school tutorial service to a whole new curriculum that seeks to add a layer of efficiently recognising talents in the public education system.
      </p>
      </div>

        {/* Our Values & Vision Card */}
        <div className="about-card">
      <SectionTitle title="Our Values & Vision" />
      <p>
            We believe in collaboration, integrity, and a commitment to
            open-source learning. Our pillars of success are only <strong>Peace</strong>,for an ordered world,  <strong>Purpose</strong>, for a united and selfless world, <strong>Happiness</strong>, for putting a smile to those we love.  
      </p>
      <p>
      The current strategy to realise our sucess is simply to empower students, educators,
      and researchers with AI tools that drive knowledge forward.
      </p>
      </div>

        {/* Our Focus Card */}
        <div className="about-card">
      <SectionTitle title="Our Focus" />
      <p>
        Our primary initiatives include AI-powered research projects,
        academic collaboration, and tech-driven learning platforms designed
        to enhance global education.
      </p>
      <p>
        We believe that our students should earn for learning and we are focusing on that. In the income-earning journey of our students we document their skills as they learn.
      </p>
      </div>
      </div>

      {/* Founding Team Section */}
      <FoundingTeam />
    </div>
  );
};

export default AboutUs;
